import Image from "next/image";
import styles from "./LeadershipHero.module.css";

interface Image {
  id: number;
  documentId: string;
  url: string;
  alternativeText: string;
}
interface LeadershipBanner {
  id: number;
  title: string;
  description: string | null;
  desktop_img: Image;
  mobile_img: Image;
}
interface Props {
  data: LeadershipBanner;
}
const LeadershipHero: React.FC<Props> = ({ data }) => {
  return (
    <section className={styles.heroSection}>
      <div className={styles.overlay}>
        <h1 className={styles.heroText}>{data?.title}</h1>
      </div>
      {/* Background Image */}
      <Image
        src={data?.desktop_img?.url}
        alt={data?.desktop_img?.alternativeText || "Hero Banner"}
        title={data?.desktop_img?.alternativeText || "Hero Banner"}
        fill
        style={{
          objectFit: "cover",
        }}
        priority
        className={styles.heroImage}
      />
      <div
        className={styles.mobileBackGroundImage}
        style={{
          backgroundImage: `url(${data?.mobile_img?.url})`,
        }}
      ></div>
    </section>
  );
};

export default LeadershipHero;
